import { FC, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumbs";
import Invoice from '../../components/Invoice/Invoice';
import { Box, Button, CircularProgress, Container, Stack, Typography, Drawer } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import jwt_decode from 'jwt-decode';
import AppBar from "@mui/material/AppBar";
import { fetchInvoicePaymentReceiptPreview} from '../../store/invoiceStore/invoiceThunk';
import { InvoicePreviewPayload, InvoicePreviewResponse } from "../../utils/invoice.types";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import HomeHeader from "../SignIn/HomeHeader";
import DialogShareInvoiceReciept from '../../components/DialogShareInvoiceReciept/DialogShareInvoiceReciept';
import ShareIcon from '@mui/icons-material/Share';

// Preview Invoice page.
const InvoicePaymentReceiptPreview: FC = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isLoggedIn } = useAppSelector((state) => state.auth);
  const [pdfLocation, setPdfLocation] = useState<string>("");
  const [curInvocieId, setCurInvoiceId] = useState<any>("");
  const [invoicePreview, setInvoicePreviewResponse] = useState<any>();
  const [showSendButton, setShowSendButton] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [openShareInvoiceRecieptDrawer, setOpenShareInvoiceRecieptDrawer] = useState<boolean>(false);

  const openShareInvoiceDrawer = (event: any) => {
    console.log(" openShareInvoiceDrawer drawer called");
    setOpenShareInvoiceRecieptDrawer(true);
    event.stopPropagation();
  };

  const handleCloseDrawer = () => {
    setOpenShareInvoiceRecieptDrawer(false);
  };


  useEffect(() => {
    console.log("use effect called 9999 ");
    const templateId = searchParams.get("templateId");
    const type = searchParams.get("type");
    setShowSendButton(true);

    const getPreview = async () => {
      let reqObj: InvoicePreviewPayload = { invoiceId: invoiceId, templateId: templateId };
      let invoicePreviewResponse: any = await dispatch(fetchInvoicePaymentReceiptPreview(reqObj));
      console.log(invoicePreviewResponse);

      let location = null;
      if (invoicePreviewResponse?.payload) {
        if (invoicePreviewResponse.payload.length > 0) {
          location = invoicePreviewResponse.payload[0].Location;
        } else {
          location = invoicePreviewResponse.payload.Location;
        }
        setPdfLocation(location);
        setInvoicePreviewResponse(invoicePreviewResponse.payload)
        setCurInvoiceId(invoiceId)
      }
      console.log("out of if ");
      setIsLoading(false);
    };

    if (templateId) {
      getPreview();
    } else {
      if (invoiceId) {
        try {
          console.log(invoiceId);
          console.log("Decoding Jwt Token for pdf");
          let token: any = jwt_decode(invoiceId);
          setPdfLocation(token.pdfLcation);
          setIsLoading(false);
        } catch (error) {

        }
      }
    }
  }, [invoiceId])

  return (
    (isLoading ? <CircularProgress /> :
      <>
        <Grid container rowSpacing="24" columnSpacing="5">
          <Container component="main" >
            {!isLoggedIn &&
              <div style={{ "width": "70vw" }}>
                <div className="preview">
                  <HomeHeader />
                </div>
                <Box onClick={() => { navigate("/") }}
                  style={{ "float": "right", "marginTop": "-42" }}
                  sx={{ cursor: "pointer" }}>
                  <Button
                    disableElevation
                    sx={{ mt: "20px" }}
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary">
                    Login/Signup
                  </Button>
                </Box>
                <p style={{ "clear": "both" }} />
              </div>
            }
            {isLoggedIn &&   
              <Box style={{ "width": "70vw" }}>
                <Stack direction="row"
                  justifyContent="space-between"
                  alignItems="baseline" sx={{ mb: { xs: 0.9, sm: 0.9 } }}
                  style={{ "float": "right", "paddingBottom": "20px" }}>
                  <Box onClick={() => { }}
                    sx={{ cursor: "pointer" }}
                  >
                    {showSendButton &&
                      
                      <Button
                        style={{paddingBottom: '10px'}}
                        disableElevation
                        sx={{ mt: "20px" }}
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={(e) => openShareInvoiceDrawer(e)}
                        >
                        <ShareIcon  style={{"marginRight": '10px'}}/>
                        Share Payment Receipt
                      </Button>}
                  </Box>
                </Stack>
              </Box>
            }
            <p style={{ "clear": "both" }}></p>
            <Box>
              <object style={{ height: "80vh", width: "70vw" }} data={pdfLocation} type="application/pdf" >
              </object>
            </Box>

          </Container>
        </Grid>
        <div style={{ minHeight: '400px', height: 'calc(100% - 80px)', width: '100%' }}>          
          <Drawer
              disableEscapeKeyDown={false}
              anchor="right"
              onClose={handleCloseDrawer}
              open={openShareInvoiceRecieptDrawer}>
              <DialogShareInvoiceReciept
                  dispatchType="Payment Receipt"
                  invoiceId={curInvocieId}
                  invoicePreviewData={invoicePreview}
                  selectedBuyer={''}
                  onClose={handleCloseDrawer}
                  openDrawer={openShareInvoiceRecieptDrawer}>
              </DialogShareInvoiceReciept>
          </Drawer>
        </div>
      </>
    )
  );
};

export default InvoicePaymentReceiptPreview;
